import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, IAM_REPORT_URL } from '../../../services/TapApiUrls';
import TapHelper from '../../../services/TapHelper';
import TapIcon from '../../../services/TapIcon';
import PageHeader from '../../includes/PageHeader';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import DateService from '../../../services/DateService';
import DownloadFile from '../../../services/DownloadFile';
import moment from 'moment';

const SiteWiseAssetTransitionReport = forwardRef((props, ref) => {

    let initListData    =    {
                                loading        : false,
                                data_loaded    : false,
                                show           : false,
                                items          : [],
                                page           : 1
                             };

    let initFormData    =   {
                                show                    :   true,
                                per_page                :   50,
                                form_data_loaded        :   false,
                                loading                 :   false,
                                downloading             :   false,
                                sites                   :   [],
                                search_site_id          :   '',
                                selected_assets         :   [],
                                search_asset_ids        :   [],
                                search_asset_type_ids   :   [],
                                asset_types             :   [],
                                search_asset_type       :   [],
                                periods                 :   [],
                                date_range              :   'current_year',
                                date_range_start        :   '',
                                date_range_end          :   '',
                            };

    let formDataLabel   =   {
                                search_site_id: 'Site : ',
                                date_range: 'Period : ',
                                search_asset_ids: 'Asset : ',
                                search_asset_type_ids: 'Asset Type : ',

                            };

    const criteriaRef       =   useRef()
    const access_token      =   useSelector(state => state.auth.access_token);
    const all_periods       =   useSelector(state => state.app.all_periods) || [];
    const user_sites        =   useSelector(state => state.app.user_sites ? state.app.user_sites : []);
    const asset_type        =   useSelector(state => state.app.asset_type ? state.app.asset_type : []);


    let itemListUrl         =   IAM_REPORT_URL + "/site_wise_asset_transition";

    const [reportData, setReportData]           =   useState(initListData);
    const [formData, setFormData]               =   useState(initFormData);
    const [searchedElems, setSearchedElems]     =   useState([]);
    const [criteriaHeight, setCriteriaHeight]   =   useState(0)

    useEffect(() => {
        updateCriteriaHeight()
    }, [reportData.show]);

    useEffect(() => {
        toggleFilterForm(true);
        loadFormData()
    }, []);

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };

    const toggleFilterForm = (show) => {
        setFormData(pd => ({ ...pd, show: show }));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    const loadFormData = () => {
        setFormData(pd => ({
            ...pd,
            form_data_loaded: true,
            loading: false,
            sites: user_sites.map((s) => {
                return { value: s.id, label: `${s.site_name} (${s.site_code})` }
            }),
            asset_types: asset_type.map((s) => { return { value: s.id, label: s.asset_type_name } }),
            periods: [...all_periods, { key: 'custom', display: 'Custom Date Range' }],

        }));
    }

    const closeReport = () => props.history.push({ pathname: `/report` })

    const submitSearchFormHandler = (e) => {
        e.preventDefault();
        toggleFilterForm(false);
        let searchedElems = [];
        let searchParams = {};

        Object.keys(formData).map((key) => {
            let label = formDataLabel[key];
            let value = formData[key];

            if (value !== null && value !== undefined && value !== '' &&
                !(Array.isArray(value) && value.length === 0)) {

                searchParams[key] = value;

                if (label) {
                    let show_val = value;

                    if (key == 'search_site_id') {
                        const site = formData.sites.find(s => s.value == value);
                        show_val = site ? site.label : value;
                    }
                    else if (key == 'search_asset_ids') {
                        show_val = formData.selected_assets ?
                            formData.selected_assets.map(s => s.display_label).join(', ') : '';
                    }
                    else if (key == 'search_asset_type_ids') {
                        show_val = formData.asset_types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    else if (key == 'date_range') {
                        if (value === 'custom') {
                            const start = formData.date_range_start;
                            const end = formData.date_range_end;
                            show_val = `Custom Date Range (${moment(start).format('DD-MMM-YYYY')} - ${moment(end).format('DD-MMM-YYYY')})`;
                        } else {
                            const period = formData.periods.find(p => p.key === value);
                            show_val = period ? period.display_with_date || period.display : value;
                        }
                    }

                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });

        setSearchedElems(searchedElems);
        loadReportData(1);
    }

    const loadReportData = (page = 1) => {
        setReportData(pd => ({ ...pd, show: true, data_loaded: false, loading: true, page: page, }));

        let params = {
            action: 'data',
            page: page,
            per_page: formData.per_page,
            search_site_id: formData.search_site_id,
            date_range: formData.date_range,
            ...TapHelper.pick(formData, ['search_asset_ids', 'search_asset_type_ids'])
        };

        if (formData.date_range === 'custom') {
            params.date_range_start = formData.date_range_start;
            params.date_range_end = formData.date_range_end;
        }

        Object.keys(params).forEach(key => {
            if (params[key] === null || params[key] === undefined ||
                (Array.isArray(params[key]) && params[key].length === 0) ||
                params[key] === "") {
                delete params[key];
            }
        });

        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            let respData = response.data;
            let meta = TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setReportData(pd => ({
                ...pd,
                data_loaded: true,
                items: respData.data,
                meta: meta,
            }));
        }).then(() => {
            setReportData(pd => ({ ...pd, loading: false }));
        });
    }

    const reportDownloadHandler = () => {
        let params = { action: 'download', ...TapHelper.pick(formData, ['search_asset_ids', 'search_asset_type_ids', 'search_site_id', 'date_range']) };

        setReportData(pd => ({ ...pd, downloading: true }));

        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            DownloadFile.file(null, response.data.msg, response.data.navigation,  props)
        }).then(() => {
            setReportData(pd => ({ ...pd, downloading: false }));
        });
    }
    const filterFormJsx = () => {
        return (
            <form onSubmit={submitSearchFormHandler} className={['p-3', 'filter_form'].join(' ')}>
                <div className="row mb-3">
                    <label className="col-sm-3 col-form-label text-end require">
                        Site
                    </label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.sites}
                            changeEvent={so => {
                                setFormData(d => ({
                                    ...d,
                                    search_site_id: so ? so.value : '',
                                }));
                            }}
                            isSearchable={true}
                            isClearable={true}
                            value={formData.sites.find(s => formData.search_site_id == s.value) || null}
                            placeholder="Select Site"
                            required={true}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-sm-3 col-form-label text-end">Asset</label>
                    <div className="col-sm-6">
                        <InputAssetSearch
                            placeholder="Search Assets"
                            filter={true}
                            isMulti={true}
                            value={formData.selected_assets ? [...formData.selected_assets] : []}
                            changeEvent={(so) => {
                                setFormData(d => ({
                                    ...d,
                                    search_asset_ids: so ? so.map(s => s.value) : [],
                                    selected_assets: so && so.length > 0 ?
                                        so.map(a => { a.label = a.display_label; return a; }) : []
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.asset_types}
                            changeEvent={o => setFormData(d => ({ ...d, search_asset_type_ids: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.asset_types.filter(s => formData.search_asset_type_ids.includes(s.value))}
                            placeholder="Select Asset Type"
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-sm-3 col-form-label text-end">Period</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods={formData.periods}
                            value={formData.date_range}
                            startDate={formData.date_range_start}
                            endDate={formData.date_range_end}
                            onSelectPeriod={(period, startDate, endDate) => {
                                setFormData({
                                    ...formData,
                                    date_range: period,
                                    date_range_start: startDate,
                                    date_range_end: endDate
                                })
                            }}
                        />
                    </div>
                </div>
                <div className="row my-4 border-bottom">
                    <div className="pb-3 col-sm-9 text-end">
                        <div className='d-flex justify-content-end align-items-center gap-2'>
                            <button type="submit" className="btn btn-primary px-4">Show Report</button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }

    const reportListJsx = () => {
        return <>
            <div ref={criteriaRef} style={{ position: 'sticky', top: 0, background: 'white', }}>
                <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr className='text-center'>
                        <th style={{ width: "5%" }}>S.No</th>
                        <th style={{ width: "12%" }}>Asset Name</th>
                        <th style={{ width: "12%" }}>Asset code</th>
                        <th style={{ width: "10%" }}>Start Date</th>
                        <th style={{ width: "10%" }}>End Date</th>
                        <th style={{ width: "10%" }}>Total Days</th>
                        <th style={{ width: "14%" }}>Start CL</th>
                        <th style={{ width: "14%" }}>End CL</th>
                        <th style={{ width: "10%" }}>Total Running</th>
                    </tr>
                </thead>
                <tbody>
                    {reportData.loading
                        ? <tr><td className='text-center' colSpan={9}><Loader /></td></tr>
                        : ((reportData.items && reportData.items.length > 0)
                            ? reportData.items.map((item, index) => {
                                return <tr className='text-center' key={item.id || index}>
                                    <td className='text-center'>
                                        {reportData.meta ? reportData.meta.from + index : index + 1}
                                    </td>
                                    <td className='text-center'>{item.name || "-"}</td>
                                    <td className='text-center'>{item.asset_code || "-"}</td>
                                    <td className='text-center'>{item.from ? DateService.dateFormat(item.from): "Since inception"}</td>
                                    <td className='text-center'>{item.till ? DateService.dateFormat(item.till): "Till Date"}</td>
                                    <td className='text-center'>{item.from && item.total_days}</td>
                                    <td className="text-end">
                                        {item.asset_reading.length > 0 ? item.asset_reading.map(item => {
                                            const isDateLabel = item.label === 'Date';
                                            return (
                                                <div>
                                                    {item.label}
                                                    {isDateLabel ? "" : ` (${item.unit})`} :
                                                    {item.key === 'start' ?
                                                        moment(item.start, 'YYYY-MM-DD').format('DD-MMM-YYYY') :
                                                        (item.start ? item.start : '-')}
                                                </div>
                                            );
                                        }) : ""}
                                    </td>
                                    <td className="text-end">
                                        {item.asset_reading.length > 0 ? item.asset_reading.map(item => {
                                            const isDateLabel = item.label === 'Date';
                                            return (
                                                <div>
                                                    {item.label}
                                                    {isDateLabel ? "" : ` (${item.unit})`} :
                                                    {item.key === 'end' ?
                                                        moment(item.end, 'YYYY-MM-DD').format('DD-MMM-YYYY') :
                                                        (item.end ? item.end : '-')}
                                                </div>
                                            );
                                        }) : ""}
                                    </td>
                                    <td className='text-end'>
                                        {item.asset_reading && item.asset_reading.length > 0 ? (
                                            item.asset_reading.map((reading, idx) => <div key={idx}>{reading.running_display || "-"}</div>)
                                        ) : "-"}
                                    </td>
                                </tr>
                            })
                            : <tr><td className='text-center' colSpan={9}>No Record Found</td></tr>)
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={reportData.meta} onPageChange={(e) => loadReportData(e.selected + 1)} />
        </>
    }

    const topRightHeaderJsx = () => {
        return <>
            <div className="text-end mt-2">
                <button type="button"
                    disabled={reportData.downloading || reportData.loading || formData.loading}
                    className="btn btn-secondary"
                    onClick={() => toggleFilterForm(!formData.show)}>
                    Change Filter
                </button>

                {reportData.data_loaded && <button type="button" 
                    disabled={reportData.downloading || reportData.loading || formData.loading} className="btn btn-secondary" onClick={reportDownloadHandler}
                    > <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                    {reportData.downloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />}
                </button> }
                <button type="button" className="btn btn-secondary mx-1" onClick={closeReport}>
                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close report" />
                </button>
            </div>
        </>
    }

    return (
        <ApplicationLayout>
            <PageHeader title="Site wise Asset Transition Report" name="Site wise Asset Transition Report" rightTopHeadingJsx={topRightHeaderJsx()} />
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                        <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide'].join(" ")}>
                            {formData.loading ? <Loader /> : filterFormJsx()}
                        </div>
                        {reportData.show && reportListJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
});

export default SiteWiseAssetTransitionReport;